import {
  DEFAULT_LOCALE_PREFIX,
  LOCALE_COOKIE,
  TAbsoluteLocale,
  ABSOLUTE_LOCALES,
  SUPPORTED_COUNTRIES,
} from '@src/config/i18n.config'
import { IS_I18N_ENABLED } from '@src/constants/storage'
import getCookie from '@src/quince-site-common/src/utils/getCookie'
import { getStandardLocale } from '@src/utils/i18n.utils'
import { getLocaleFromUrlPath } from '@src/utils/urlLocale.utils'

const CHECKOUT_PATH = '/checkout'

export const getLocalePrefix = (): string => {
  try {
    const locale = getCookie(LOCALE_COOKIE) as TAbsoluteLocale
    if (locale) {
      const localePrefix = getStandardLocale(locale)
      return localePrefix
    }
    return getLocaleFromUrlPath(DEFAULT_LOCALE_PREFIX)
  } catch (error) {
    console.error('Error getting locale prefix:', error)
    return DEFAULT_LOCALE_PREFIX
  }
}

const getLocalePath = (): string => {
  const pathSegments = window.location.pathname.split('/').filter(segment => segment.length > 0)
  const firstSegment = pathSegments[0]
  const validLocalesLowercase = [...ABSOLUTE_LOCALES, ...SUPPORTED_COUNTRIES].map(locale => locale.toLowerCase())
  return firstSegment && validLocalesLowercase.includes(firstSegment.toLowerCase()) ? `/${firstSegment}` : ''
}

/**
 * Creates a locale-prefixed checkout URL
 * @param baseUrl - The base checkout URL
 * @param checkoutId - The checkout ID
 * @param checkoutAuthCode - The checkout auth code
 * @returns The complete checkout URL with locale prefix (only if different from default)
 */
export const createLocalePrefixedCheckoutUrl = (
  baseUrl: string,
  checkoutId: string,
  checkoutAuthCode: string,
): string => {
  const localePrefix = getLocalePrefix()
  const url = new URL(baseUrl)

  // Only add locale prefix if it's different from the default locale
  if (localePrefix === DEFAULT_LOCALE_PREFIX || !IS_I18N_ENABLED) {
    url.pathname = CHECKOUT_PATH
  } else {
    url.pathname = `${getLocalePath()}${CHECKOUT_PATH}`
  }

  url.searchParams.set('checkoutId', checkoutId)
  url.searchParams.set('checkoutAuthCode', checkoutAuthCode)

  return url.href
}
